export class GetTransactionRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  categoryCode: string | null = null;
  merchantCode: string | null = null;
  providerCode: string | null = null;
  productCode: string | null = null;
  type: string = '1'; // value 1 is transaction type
  status: string | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
}

export class CreateTransactionParams {
  id: string = '';
  name: string = '';
  user: string = '';
  password: string = '';
  secret_code: string = '';
  base_url: string = '';
  method: string = '';
  inq_param: string = '';
  pay_param: string = '';
  adv_param: string = '';
  reversal_param: string = '';
  inq_url: string = '';
  pay_url: string = '';
  adv_url: string = '';
  reversal_url: string = '';
}

export class UpdateTransactionRequestParams extends CreateTransactionParams {
  oldPassword?: string;
}

export interface TransactionData {
  id: string;
  name: string;
  user: string;
  password: string;
  secret_code: string;
  base_url: string;
  method: string;
  inq_param: string;
  pay_param: string;
  adv_param: string;
  reversal_param: string;
  inq_url: string;
  pay_url: string;
  adv_url: string;
  reversal_url: string;
  created_at: string;
  updated_at: string;
}

export interface GetTransactionResponse {
  code: number;
  message: string;
  data: TransactionData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetTransactionByIdResponse {
  code: number;
  message: string;
  data: TransactionData;
}

export interface DeleteTransactionByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
